
const homeStyle = theme => ({
    contentArea: {
        background: "white",
        height: "100vh"
    },
    wrapper: {
        top: "0",
        height: "100vh"
    },
    container: {
        display: "flex"
    }
});

export default homeStyle;
